import React from "react";

const ProgressBar = ({ currentSlide, totalSlides, color, showText = true, progressBarText }) => {
  // Set progress percentage
  const progress = ((currentSlide + 1) / (totalSlides - 1)) * 100;

  return (
    <div className="form-header-container" style={{
      width: "100%",
      backgroundColor: "#F9F9F9",
    }}>
      <div className="form-header-container__inner" style={{
        width: "100%",
        display: "flex",
        gap: "16px",
      }}>
        <p>
          {progressBarText}
        </p>
        <div class="progress-bar__wrapper" style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          gap: "16px",
        }}>
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              backgroundColor: "#ffffff",
              height: "8px",
              borderRadius: "99px",
            }}
          >
            <div
              style={{
                width: `${progress}%`,
                backgroundImage: "linear-gradient(90deg, #35265F 0%, #DE1F2F 100%)",
                height: "8px",
                borderRadius: "99px",
              }}
            ></div>
          </div>

          {showText && (
            <p style={{ textAlign: "center" }}>
              {Math.floor(((currentSlide + 1) / (totalSlides - 1)) * 100)}%
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
